/** Minimal hash router: #/live, #/analysis, #/settings, #/selftest */
import { parseHash, type Route } from './routes';

export type { Route } from './routes';

class Router {
  current = $state<Route>(parseHash(location.hash));

  constructor() {
    addEventListener('hashchange', () => {
      this.current = parseHash(location.hash);
    });
  }

  href(r: Route): string {
    return `#/${r}`;
  }
}

export const router = new Router();
